import { Sector } from '@/domain/impact/impact.entity.ts';

export const questionsBySectorEnv: Record<Sector, Array<string>> = {
  '': [],
  ANY: [],
  TEAM: [
    'ENV_19',
    'ENV_22',
    'ENV_28',
    'ENV_31_1',
    'QP_ENV_6',
    'ENV_45',
    'ENV_46',
    'ENV_47',
    'ENV_48',
    'ENV_43',
    'QP_ENV_8',
    'ENV_51',
    'ENV_51_5',
    'ENV_52',
  ],
  ARTISTS: [
    'QP_ENV_2',
    'ENV_2',
    'ENV_3_5',
    'ENV_4_5',
    'ENV_5_5',
    'ENV_6_5',
    'ENV_7_5',
    'ENV_8_5',
    'ENV_9_2',
    'ENV_12',
    'ENV_15',
    'ENV_33',
    'ENV_68_2',
  ],
  PUBLIC: [
    'QP_ENV_1',
    'ENV_1',
    'ENV_3',
    'ENV_4',
    'ENV_5',
    'ENV_6',
    'ENV_7',
    'ENV_8',
    'ENV_9',
    'ENV_9_5',
    'ENV_10',
    'QP_ENV_3',
    'ENV_11',
    'ENV_13',
    'ENV_14',
    'ENV_16',
    'ENV_32',
    'ENV_44',
    'QP_ENV_7',
    'ENV_48_5',
    'ENV_49',
    'QP_ENV_9',
    'ENV_53',
    'ENV_54',
    'ENV_56',
    'ENV_57',
    'ENV_59',
    'QP_ENV_10',
    'ENV_58',
    'ENV_59',
    'ENV_60',
    'ENV_61',
    'ENV_62',
    'ENV_63',
    'ENV_66',
    'ENV_67',
    'ENV_68',
    'ENV_68_1',
    'ENV_69',
    'ENV_70',
    'ENV_71',
    'ENV_72',
  ],
  SITE: [
    'ENV_18',
    'ENV_20',
    'ENV_27bis',
    'ENV_21',
    'ENV_23',
    'ENV_24',
    'ENV_25',
    'ENV_26',
    'ENV_27',
    'ENV_29',
    'QP_ENV_4',
    'ENV_36_5',
    'ENV_31',
    'ENV_34',
    'ENV_34_5',
    'ENV_35',
    'QP_ENV_5',
    'ENV_36',
    'ENV_37',
    'ENV_38',
    'ENV_39',
    'ENV_40',
    'ENV_41',
    'ENV_42',
    'ENV_55',
    'ENV_55_5',
  ],
};
